module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>'+
((__t=( name ))==null?'':__t)+
'</td>\n<td>'+
((__t=( role ))==null?'':__t)+
'</td>\n';
}
return __p;
};
